module.exports = __webpack_public_path__ + "img/2.3186735d.png";